import { render } from "./RecordHistoryBoard.vue?vue&type=template&id=666b9851&scoped=true&ts=true"
import script from "./RecordHistoryBoard.vue?vue&type=script&lang=ts"
export * from "./RecordHistoryBoard.vue?vue&type=script&lang=ts"

import "./RecordHistoryBoard.vue?vue&type=style&index=0&id=666b9851&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b9851"]])

export default __exports__